interface WorldchainIconProps {
  className?: string
}

export function WorldIcon({ className }: WorldchainIconProps) {
  return (
    <svg viewBox="0 0 600 600" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <circle cx="300" cy="300" r="300" fill="black" />
      <g transform="translate(-99.689875,-99.947068)">
        <g transform="matrix(1.2367001,0,0,1.2367001,-668.2998,-668.50879)">
          <g transform="matrix(1.2994699,0,0,1.2994699,725.31494,727.89368)">
            <g transform="translate(131.17999,104.74)">
              <path
                strokeLinecap="round"
                strokeLinejoin="miter"
                fillOpacity="0"
                strokeMiterlimit="10"
                stroke="white"
                strokeOpacity="1"
                strokeWidth="35px"
                d="m 119.067,-87.470001 c 0,0 -145.507001,0.230003 -145.507001,0.230003 C -74.620003,-87.239998 -113.68,-48.18 -113.68,0 c 0,48.18 39.059997,87.239998 87.239999,87.239998 0,0 140.120001,0 140.120001,0"
              />
            </g>
          </g>
          <g transform="matrix(1.2994699,0,0,1.2994699,643.73987,841.25928)">
            <path
              strokeLinecap="round"
              strokeLinejoin="miter"
              fillOpacity="0"
              strokeMiterlimit="10"
              stroke="white"
              strokeOpacity="1"
              strokeWidth="35px"
              d="m 2.309,17.5 c 0,0 336.11101,0 336.11101,0"
            />
          </g>
          <g transform="matrix(1.2994699,0,0,1.2994699,620.99915,621.3761)">
            <g transform="translate(186.71001,186.71001)">
              <path
                strokeLinecap="round"
                strokeLinejoin="miter"
                fillOpacity="0"
                strokeMiterlimit="10"
                stroke="white"
                strokeOpacity="1"
                strokeWidth="35px"
                d="M 0,-169.21001 C 93.452003,-169.21001 169.21001,-93.452003 169.21001,0 169.21001,93.452003 93.452003,169.21001 0,169.21001 -93.452003,169.21001 -169.21001,93.452003 -169.21001,0 -169.21001,-93.452003 -93.452003,-169.21001 0,-169.21001 Z"
              />
            </g>
          </g>
        </g>
      </g>
    </svg>
  )
}
